import React from 'react';

interface StateProps {
  icon?: string;
  label: string;
  className?: string;
}

type Props = StateProps;

const menuItem = ({ icon, label, className }: Props) => (
  <li className={className}>
    <i className={`fa fa-${icon}`} />
    <span>{label}</span>
  </li>
);

export default menuItem;
